import { useEffect, useState } from "react";
import { listQueuedSubmissions } from "../lib/offline/db";

export const useQueuedSubmissionCount = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const entries = await listQueuedSubmissions();
        if (!cancelled) {
          setCount(entries.length);
        }
      } catch (error) {
        console.warn("Failed to load queued submission count", error);
      }
    };

    load();
    const interval = window.setInterval(load, 10_000);

    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, []);

  return count;
};
